import PhoneNumber from './PhoneNumber';
export default function getExampleNumber(country, examples, metadata) {
  if (examples[country]) {
    return new PhoneNumber(country, examples[country], metadata);
  }
}
//# sourceMappingURL=getExampleNumber.js.map


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/es6/getExampleNumber.js
// module id = BnHu
// module chunks = 1